require('/opt/odin/app/frontend/components/percent_bar/index.module.scss');module.exports = "../../app/cells/components/percent_bar/show.erb";